import React, { Component } from 'react'
import firebase from 'firebase'
import { Helmet } from "react-helmet";
import swal from 'sweetalert2'

class Link extends Component {
  state = {
    username: this.props.username || '',
    isVerified: false,
    isFree: false
  }

  onChange = e => {
    this.setState({ username: e.target.value, isVerified: false, isFree: false }, () => {
      if (this.timeout) {
        clearTimeout(this.timeout)
      }

      const { username } = this.state
      const usernameEdited = username.replace(/ /g, '').replace(/,/g, '').toLowerCase()

      // not empty
      if (usernameEdited) {
        this.timeout = setTimeout(() => {
          firebase.database().ref('Usernames')
            .orderByValue()
            .equalTo(usernameEdited)
            .once('value')
            .then(snap => {
              const isFree = !Boolean(snap.val())

              this.setState({
                isVerified: true,
                isFree
              })
            })
        }, 200)
      }
    })
  }

  saveUsername = () => {
    const { username, isFree, isVerified } = this.state
    const { user } = this.props

    const usernameEdited = username.replace(/ /g, '').replace(/,/g, '').toLowerCase()

    if (isFree && isVerified && usernameEdited && user) {
      const updates = {}
      updates['Usernames/' + user.uid] = usernameEdited
      updates['List/' + user.uid] = firebase.database.ServerValue.TIMESTAMP
      firebase.database().ref().update(updates)
    } else {
      swal({
        title: 'Oops!',
        text: 'Invalid username',
        type: 'error',
        confirmButtonText: 'Got it!'
      })
    }
  }

  render() {
    const { username, isFree, isVerified } = this.state
    const usernameEdited = username.replace(/ /g, '').replace(/,/g, '').toLowerCase()

    return (
      <div>
        <Helmet titleTemplate="just.is - %s">
          <title>username</title>
          <meta name="description" content="Nested component" />
        </Helmet>
        <div class="form">



          <div class="sign-in-form username">
            {!isVerified && username && <span></span>}
            {isVerified &&
              <span class="absolute">{isFree ? <span>{username} is available! 👍</span> : <span>{username} is taken! 👎</span>}</span>
            }
            <br /> 
            
            <div>
              <div>
                <input class="username" placeholder="type username" type="text" value={username} onChange={this.onChange} />
                <div class="col-4 left">
                  <h4>you will get urls like this.</h4>
                  <li> just.is/<strong>{usernameEdited}</strong>    </li>
                  <li>   <strong>{usernameEdited}</strong>.just.is   </li>
                  <li>      playlist.is/<strong>{usernameEdited}</strong></li>
                  <li>   <strong>{usernameEdited}</strong>.quik.site   </li>
                </div>
                <div class="col-4 left">
                  <h4>and this.</h4>
                  <li>   <strong>{usernameEdited}</strong>.u-r.work   </li>
                  <li>   moood.ooo/<strong>{usernameEdited}</strong>  </li>
                  <li>    hmu.bet/<strong>{usernameEdited}</strong>  </li>
                </div>
                <div class="col-4 left">
                  <h4>and other thingys like.</h4>
                  <li>   sell.now.sh/<strong>{usernameEdited}</strong>  </li>
                  <li>    n0t.es/<strong>{usernameEdited}</strong> </li>
                  <li>     01-dj.com/<strong>{usernameEdited}</strong></li>
                </div>
                <div class="clearfix"></div>
                <br />
                <div class="col-4 left">
                  <p><small><i> & maybe even <strong>{usernameEdited}</strong>@just.is</i></small> </p>
              <small>+ more.</small>
</div>
              </div>

              <div class="clearfix"></div>

            <div class="center">  <button class="google" onClick={this.saveUsername}><h3>reserve username</h3></button>
</div>
     
            </div>

            <p class="dontworry"><small><b>*</b>don't worry you can change it later.</small></p>
            <p class="dontworry"><small><b>**</b>usernames are not guaranteed but pretty much are haha, there's code things & friends who may need & too lazy to go thru both for now. yktfv. </small></p>
            <p class="dontworry"><small><b>***</b>open up in incognito window if you want to reserve more than one username. yktfv again. </small></p>

            <br />

            <div class="sign-up-container">
            </div>

          </div>
          {/* <div class="center"><div class="bck" onClick={() => this.props.history.goBack()}><img src='https://icon.now.sh/arrow/left' alt='chevron icon' />&nbsp;back to email</div>
          </div> */}
        </div>

      </div>
    )
  }
}

export default Link



// WEBPACK FOOTER //
// ./src/routes/Username.js